import * as Models from "app/services/proxy/model/models";
import {ForecastDuration} from "app/shared/filters/widget-filter/widget-filtering";

import {MomentHelper} from "framework/ui/formatting/date-format.pipe";

export function normalizeForecastPeriodStart(date: Date | number,
                                             granularity: Models.TrendGranularity,
                                             fiscalStartMonth: number = 0): number
{
    const value = MomentHelper.parseAsUTC(date);

    switch (granularity)
    {
        case Models.TrendGranularity.quarter:
        {
            const monthOfYear           = value.month();
            const monthsFromFiscalStart = (monthOfYear - fiscalStartMonth + 12) % 12;
            const quarterIndex          = Math.floor(monthsFromFiscalStart / 3);
            const fiscalQuarterMonth    = (fiscalStartMonth + quarterIndex * 3) % 12;
            const year                  = fiscalQuarterMonth > monthOfYear ? value.year() - 1 : value.year();

            return Date.UTC(year, fiscalQuarterMonth, 1);
        }

        case Models.TrendGranularity.year:
        {
            const year = value.month() < fiscalStartMonth ? value.year() - 1 : value.year();
            return Date.UTC(year, fiscalStartMonth, 1);
        }

        case Models.TrendGranularity.week:
            return value.startOf("isoWeek")
                        .valueOf();

        default:
            return value.startOf(granularity)
                        .valueOf();
    }
}

export function forecastRangeEnd(rangeEnd: number,
                                 now: number,
                                 forecast: ForecastDuration,
                                 trendGranularity: Models.TrendGranularity,
                                 fiscalStartMonth: number = 0,
                                 nowOffsetDays: number = 0): number
{
    const isT2Range  = nowOffsetDays > 0;
    const rangeAnchor = isT2Range ? rangeEnd : Math.max(rangeEnd, now);
    const anchor      = isT2Range && trendGranularity === Models.TrendGranularity.day && forecast.granularity === Models.TrendGranularity.day
        ? MomentHelper.parseAsUTC(rangeAnchor)
                      .startOf("day")
                      .add(1, "day")
                      .valueOf()
        : rangeAnchor;
    const periodStart = normalizeForecastPeriodStart(anchor, forecast.granularity, fiscalStartMonth);

    return MomentHelper.parseAsUTC(periodStart)
                       .add(forecast.count, forecast.granularity)
                       .subtract(1, "millisecond")
                       .valueOf();
}

// Chart end date is just the range's own end, unless a forecast is active -- then it extends
// out to the end of the forecasted fiscal period.
export function resolveChartEndDate(rangeEnd: number,
                                    now: number,
                                    forecast: ForecastDuration | undefined,
                                    trendGranularity: Models.TrendGranularity,
                                    fiscalStartMonth: number = 0,
                                    nowOffsetDays: number = 0): number
{
    return forecast ? forecastRangeEnd(rangeEnd, now, forecast, trendGranularity, fiscalStartMonth, nowOffsetDays) : rangeEnd;
}
